import React from "react";
import { Line } from "react-chartjs-2";
import { getLabelsFromDataPoint } from "../outboundAmzl/util/Util";

const PVAChart = (data) => {
  const getLabels = () => {
    if (data.processName === "outbound") {
      const pickData = data.pvaData.pvaData.pick;
      return pickData.flowPVAData
        ? getLabelsFromDataPoint(
            pickData.flowPVAData[data.pvaData.pvaData.pvaGraphData.granularity]
              .dataPointList,
          )
        : [];
    } else {
      const overviewData = data.pvaData.pvaData.overviewData;
      return getLabelsFromDataPoint(
        overviewData.flowPVAData[
          data.pvaData.pvaData.pvaGraphData.granularity
        ][0].dataPointList,
      );
    }
  };

  return (
    <div>
      <Line
        data={{
          labels: getLabels(),
          datasets: data.pvaData.pvaData.pvaGraphData.processName.map(
            (process) => {
              if (process === "inbound") {
                return {
                  data: data.pvaData.pvaData.inbound
                    ? data.pvaData.pvaData.inbound.flowPVAData[
                        data.pvaData.pvaData.pvaGraphData.granularity
                      ][0].dataPointList.map(
                        (dataPoint) => dataPoint.metricValue,
                      )
                    : [],
                  fill: false,
                  label: "inbound",
                  borderColor: "#FF7494",
                };
              }
              if (process === "induct") {
                return {
                  data: data.pvaData.pvaData.overviewData.flowPVAData[
                    data.pvaData.pvaData.pvaGraphData.granularity
                  ][0].dataPointList.map((dataPoint) => dataPoint.metricValue),
                  fill: false,
                  label: "induct",
                  borderColor: "#00A8E1",
                };
              }
              if (process === "sort") {
                return {
                  data: data.pvaData.pvaData.overviewData.flowPVAData[
                    data.pvaData.pvaData.pvaGraphData.granularity
                  ][2].dataPointList.map((dataPoint) => dataPoint.metricValue),
                  fill: false,
                  label: "sort",
                  borderColor: "#ADE422",
                };
              }
              if (process === "pick") {
                return {
                  data: data.pvaData.pvaData.pick.flowPVAData
                    ? data.pvaData.pvaData.pick.flowPVAData[
                        data.pvaData.pvaData.pvaGraphData.granularity
                      ].dataPointList.map((dataPoint) => dataPoint.metricValue)
                    : [],
                  fill: false,
                  label: "pick",
                  borderColor: "#FF7494",
                };
              }
              if (process === "stage") {
                return {
                  data: data.pvaData.pvaData.stage.flowPVAData
                    ? data.pvaData.pvaData.stage.flowPVAData[
                        data.pvaData.pvaData.pvaGraphData.granularity
                      ].dataPointList.map((dataPoint) => dataPoint.metricValue)
                    : [],
                  fill: false,
                  label: "stage",
                  borderColor: "#00A8E1",
                };
              }
              return [];
            },
          ),
        }}
        options={{
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  drawOnChartArea: false,
                },
              },
            ],
            yAxes: [
              {
                gridLines: {
                  drawOnChartArea: false,
                },
                ticks: {
                  autoSkip: true,
                  maxTicksLimit: 5,
                },
              },
            ],
          },
        }}
      />
    </div>
  );
};

export default PVAChart;



// WEBPACK FOOTER //
// ./src/components/chart/PVAChart.js